import styled from "styled-components";

import { Caption, Paragraph2 } from "../../../components";
import { colors } from "../../../consts";

export const ActionOptionWrapper = styled.div`
  margin-left: 6px;

  ${Paragraph2} {
    font-weight: 600;

    ${(props) => !props?.isSelected && `color: ${colors.RAISIN_70};`}
  }

  ${Caption} {
    font-size: 14px;
    color: ${(props) => (props?.isSelected ? colors.RAISIN_100 : colors.RAISIN_70)};
  }
`;
